import useS3Url from "../hooks/useS3Url";

// Drop-in <img> that accepts either a full URL or an S3 key as `src`.
const S3Image = ({ src, fallback, ...props }) => {
  const url = useS3Url(src);
  if (!url && !fallback) return null;
  return <img src={url || fallback} {...props} />;
};

export default S3Image;
